// # Filename: components/board/ResponsiveBoard.jsx

import React from "react";
import classNames from "classnames";
import "./ResponsiveBoard.css";
import { XIcon, OIcon } from "./TronXO";

const ResponsiveBoard = ({
  cellValues,
  winningCombination = [],
  handleCellClick,
  isDisabled = false,
  playerRole,
  currentTurn,
  winner,
  isGameOver,
}) => {
  const renderStatus = () => {
    if (isGameOver) {
      return "Game Complete";
    }

    if (currentTurn === playerRole) return "Your turn";
    return "Opponent's turn";
  };

  return (
    <div className="responsive-game-container">
      <div
        className={classNames("turn-indicator", {
          "your-turn": !isGameOver && currentTurn === playerRole,
          "opponent-turn": !isGameOver && currentTurn !== playerRole,
          "game-over": isGameOver,
        })}
      >
        {renderStatus()}
      </div>

      <div className="board-wrapper">
        {cellValues.map((value, index) => {
          const isWinner = winningCombination.includes(index);

          const cellClass = classNames("cell", {
            winner: isWinner,
            populated: value,
          });

          return (
            <button
              key={index}
              type="button"
              className={cellClass}
              onClick={() => handleCellClick(index)}
              disabled={!!value || isDisabled}
              aria-label={`Cell ${index + 1}`}
            >
              <span className="cell-content" aria-hidden="true">
                {value === "X" && <XIcon />}
                {value === "O" && <OIcon />}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ResponsiveBoard;
